import { ColorEnum } from '@/constants/color'
import OrderListItem from '@/features/orders/components/OrderListItem'
import OrderStateAndCountdown from '@/features/orders/components/OrderStateAndCountdown'
import { useOrderDetailNavigation } from '@/features/orders/hooks/useOrderDetailNavigation'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC, memo } from 'react'
import invariant from 'tiny-invariant'

interface NewOrderListItemProps {
    uuid: string
    selected?: boolean
}

const NewOrderListItem: FC<NewOrderListItemProps> = ({ uuid, selected }) => {
    const order = useAppSelector(ordersSelectors.orderByUuid(uuid))

    const navigate = useOrderDetailNavigation()

    const deliveryTime = order?.acceptedDeliveryTime ?? order?.requestedDeliveryTime

    invariant(order && deliveryTime, 'Order with delivery time must be provided')

    return (
        <OrderListItem
            order={order}
            RightEndComponent={
                <OrderStateAndCountdown
                    deliveryTime={deliveryTime}
                    deliveryTypeCategory={order.deliveryType.typeCategory}
                    State={<OrderListItem.State />}
                />
            }
            onPress={() => navigate(uuid)}
            style={selected && { backgroundColor: ColorEnum.YELLOW_200 }}
        />
    )
}

export default memo(NewOrderListItem)
